

(function () {
  
    "use strict";

    // @ngInject
    function LoansControllerCtor($scope, $injector, $q, UsersManager, ModalService, AnalyticsService, moment) {
    
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'LoansController';
        this.moment = moment;

        this.$q = $q;
        this.UsersManager = UsersManager;
        this.ModalService = ModalService;
        this.AnalyticsService = AnalyticsService;

        this.user = UsersManager.getCurrUser();

        var loanEligibilityDate = this.moment(this.user.loan_eligibility_date).format('YYYY-MM-DD');
        var loanElligibilityType = this.user.eligible_for_qwil_loans ? "qwil" : "hb";
        AnalyticsService.trackPageView(this, 'LoansView',{eligibility_date:loanEligibilityDate, source: loanElligibilityType});

        this.initializeLoans().then(function() {
            this.doneInitilizing = true;
        }.bind(this));

        this.loansProgressMap = {};
        this.doneInitilizing = false;
    }

    Controllers.LoansController = Class(Controllers.BaseController, {
        constructor: LoansControllerCtor,

        viewDetails: function viewDetails(loan) {

            if (this.loansProgressMap[loan._id]) {
                return;
            }

            this.loansProgressMap[loan._id] = true;

            this.ModalService.openOfferLoanModal(loan)
                .then(function success() {
                    this.initializeLoans();
                }.bind(this))
                .finally(function final() {
                    this.loansProgressMap[loan._id] = false;
                }.bind(this));
        },

        loanInProgress: function loanInProgress(loan) {
            return !!this.loansProgressMap[loan._id];
        },

        initializeLoans: function initializeLoans() {

            var availableLoansPromise = this.UsersManager.getAvailableLoans().then(function(resp) {
                this.availableLoans = resp.data;
            }.bind(this));

            var existingLoansPromise = this.UsersManager.getExistingLoans().then(function(resp) {
                this.existingLoans = resp.data;
            }.bind(this));

            return this.$q.all([existingLoansPromise, availableLoansPromise]);
        }
    });
    
}());
